<p-dialog
  header="{{ 'INVOICE_POPUP.INVOICE_HEADING' | translate }}"
  [visible]="showInvoicePopup"
  modal="true"
  [closable]="true"
  (click)="onClosePopup()"
>
  <ng-container *ngIf="!loading; else loadingTemplate">
    <div class="invoice-details" (click)="$event.stopPropagation()">
      <!-- Header Section -->
      <div class="row">
        <div class="col-12 details-section">
          <div class="invoice-left-details">
            <p class="small-text fw-semibold">{{ 'INVOICE_POPUP.BILLED_TO' | translate }}</p>
            <p class="large-text fw-bolder">{{ callDetails?.callerName }} | Caller</p>
            <p
              *ngIf="callDetails?.userCity || callDetails?.userRegion || callDetails?.userCountry"
              class="medium-text fw-normal"
            >
              {{ callDetails?.userCity ? callDetails?.userCity + ', ' : '' }}
              {{ callDetails?.userRegion ? callDetails?.userRegion + ', ' : '' }}
              {{ callDetails?.userCountry || '' }}
            </p>
          </div>
          <div class="invoice-right-details">
            <p class="small-text fw-semibold">{{ 'INVOICE_POPUP.INVOICE_NO' | translate }}</p>
            <p class="medium-text fw-normal">{{ invoiceData?.invoiceNumber }}</p>
            <p class="small-text fw-semibold">{{ 'INVOICE_POPUP.ISSUED_ON' | translate }}</p>
            <p class="small-medium-text fw-bolder">
              {{
                invoiceData?.generatedOn
                  ? (getConvertedDate(invoiceData?.generatedOn || '') | date: 'dd-MMM-YYYY h:mm a')
                  : ''
              }}
            </p>
          </div>
        </div>
      </div>
      <hr class="horizontal-line" />

      <!-- Cost Section -->
      <table>
        <thead>
          <tr>
            <th class="medium-text fw-bolder">
              {{ 'INVOICE_POPUP.COST_TABLE.DESCRIPTION' | translate }}
            </th>
            <th class="small-text fw-semibold text-end">
              {{ 'INVOICE_POPUP.COST_TABLE.CALL_RATE' | translate }}
            </th>
            <th class="small-text fw-semibold text-center">
              {{ 'INVOICE_POPUP.COST_TABLE.QUANTITY' | translate }}
            </th>
            <th class="small-text fw-semibold text-end">
              {{ 'INVOICE_POPUP.COST_TABLE.COST' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let component of invoiceMetadata?.costComponents">
            <td>{{ component.name }}</td>
            <td class="text-end" *ngIf="component.type === 'Rate'">
              {{ component.componentValue || 0 | currency: component.currency }}/{{
                component.rateInterval ? component.rateInterval + ' mins' : ' - '
              }}
            </td>
            <td class="text-end" *ngIf="component.type === 'Fixed'">
              {{ component.componentValue || 0 | currency: component.currency }}
            </td>
            <td class="text-end" *ngIf="component.type === 'Percentage'">
              {{ component.componentValue + '%' }}
            </td>
            <td class="text-center">
              {{ formatDuration(component?.quantity || 0) }}
            </td>
            <td class="text-end">
              {{ component.cost | currency: component.currency }}
            </td>
          </tr>
        </tbody>
      </table>
      <hr class="horizontal-line" />

      <!-- Amount Partition -->
      <div class="total-amount-partition">
        <span class="small-text fw-normal text-start"
          >{{ 'INVOICE_POPUP.COST_TABLE.TOTAL' | translate }} ({{ invoiceData?.currency }})</span
        >
        <span class="medium-text fw-bolder text-end float-end">{{
          invoiceData?.totalAmount?.toFixed(2)
        }}</span>
      </div>

      <!-- Footer template -->
      <div class="invoice-footer row">
        <div class="footer-section company-info col-4">
          <img src="assets/icons/talking-buddy.svg" alt="talking-buddy" class="footer-logo" />
          <a href="mailto:support@talkingbuddy.com">{{
            'INVOICE_POPUP.FOOTER_DETAILS.SUPPORT_MAIL' | translate
          }}</a>
        </div>

        <div class="footer-section payment-instructions col-4">
          <p class="fw-bolder">
            {{ 'INVOICE_POPUP.FOOTER_DETAILS.PAYMENT_INSTRUCTION' | translate }}
          </p>
          <p class="mt-0">{{ 'INVOICE_POPUP.FOOTER_DETAILS.INSTRUCTION' | translate }}</p>
        </div>

        <div class="footer-section thank-you col-4">
          <p class="fw-bolder">
            {{ 'INVOICE_POPUP.FOOTER_DETAILS.THANKYOU_CHOOSING_US' | translate }}
          </p>
          <p>{{ 'INVOICE_POPUP.FOOTER_DETAILS.CONTACT_US_FOR_ISSUE' | translate }}</p>

          <p class="fw-bolder mb-0">{{ 'INVOICE_POPUP.FOOTER_DETAILS.REFER_INFO' | translate }}</p>
          <p class="mt-0">{{ 'INVOICE_POPUP.FOOTER_DETAILS.PAYMENT_POLICY' | translate }}</p>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading-spinner">
      <p>{{ 'INVOICE_POPUP.LOADING_INVOICE_DETAILS' | translate }}</p>
    </div>
  </ng-template>
</p-dialog>
